import React, { useEffect } from 'react';
import Style from './UserAttendanceStatusPage.style';
import { Headline, Spinner } from 'Common';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPaymentInfosRequest } from 'redux/actions';
import { getCurrentUser, hasZppCourseAttendances, hasSubscription, isUserPaymentInformationLoading } from 'redux/query';
import { NoSubscriptionContainer } from 'containers';
import { SubscriptionHint } from 'Component';
import {
  SubscriptionDetailProductName,
  SubscriptionDetailPayedWith,
  SubscriptionDetailRunTime,
  SubscriptionDetailAboState,
  SubscriptionDetailCourseAttendance
} from 'Component/SubscriptionDetailTable';

export const UserAttendanceStatusPage = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(isUserPaymentInformationLoading);
  const isSubscribed = useSelector(hasSubscription);
  const user = useSelector(getCurrentUser);

  const hasAttendances = useSelector(hasZppCourseAttendances);

  useEffect(() => {
    dispatch(getUserPaymentInfosRequest({ renewable: true }));
  }, []);

  return (
    <Style>
      <Headline level={1} className="headline">
        Deine Freischaltung
      </Headline>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {isSubscribed && (
            <>
              <SubscriptionHint />
              <Headline level={5} className="headline">
                Käufe
              </Headline>
              <SubscriptionDetailProductName />
              <SubscriptionDetailRunTime />
              <SubscriptionDetailAboState />
              <SubscriptionDetailPayedWith />
            </>
          )}
          {isSubscribed && hasAttendances && <br />}
          {hasAttendances && (
            <>
              <Headline level={5} className="headline">
                Krankenkasse
              </Headline>
              {user.zppCourseAttendances.map((courseAttendance, index) => (
                <SubscriptionDetailCourseAttendance key={`zpp-course-attendance-${index}`} courseAttendance={courseAttendance} />
              ))}
            </>
          )}
          {!isSubscribed && !hasAttendances && <NoSubscriptionContainer />}
        </>
      )}
    </Style>
  );
};
